import { styled } from '@abyss/web/tools/styled';
import { Link } from '@abyss/web/ui/Link';

export const ExploreUnaitedHealthPremiumLink = styled(Link, {
  fontSize: '14px !important',
  fontWeight: '600 !important',
  lineHeight: '18px !important',
  letterSpacing: '0 !important',
  color: '$interactive1 !important',
  verticalAlign: 'middle !important',
  '&::before': {
    borderBottom: 'none !important',
  },
});
